export const GET_AVAILABILITIES_BEGIN = 'GET_AVAILABILITIES_BEGIN'
export const GET_AVAILABILITIES_SUCCESS = 'GET_AVAILABILITIES_SUCCESS'
export const GET_AVAILABILITIES_ERROR = 'GET_AVAILABILITIES_ERROR'

export const DELETE_AVAILABILITY_BEGIN = 'DELETE_AVAILABILITY_BEGIN'
export const DELETE_AVAILABILITY_SUCCESS = 'DELETE_AVAILABILITY_SUCCESS'
export const DELETE_AVAILABILITY_ERROR = 'DELETE_AVAILABILITY_ERROR'

export const CREATE_AVAILABILITY_BEGIN = 'CREATE_AVAILABILITY_BEGIN'
export const CREATE_AVAILABILITY_SUCCESS = 'CREATE_AVAILABILITY_SUCCESS'
export const CREATE_AVAILABILITY_ERROR = 'CREATE_AVAILABILITY_ERROR'

export const UPDATE_AVAILABILITY_BEGIN = 'UPDATE_AVAILABILITY_BEGIN'
export const UPDATE_AVAILABILITY_SUCCESS = 'UPDATE_AVAILABILITY_SUCCESS'
export const UPDATE_AVAILABILITY_ERROR = 'UPDATE_AVAILABILITY_ERROR'

export const ADD_AVAILABILITY_SCHEDULE_BEGIN = 'ADD_AVAILABILITY_SCHEDULE_BEGIN'
export const ADD_AVAILABILITY_SCHEDULE_SUCCESS = 'ADD_AVAILABILITY_SCHEDULE_SUCCESS'
export const ADD_AVAILABILITY_SCHEDULE_ERROR = 'ADD_AVAILABILITY_SCHEDULE_ERROR'

export const DELETE_AVAILABILITY_SCHEDULE_BEGIN = 'DELETE_AVAILABILITY_SCHEDULE_BEGIN'
export const DELETE_AVAILABILITY_SCHEDULE_SUCCESS = 'DELETE_AVAILABILITY_SCHEDULE_SUCCESS'
export const DELETE_AVAILABILITY_SCHEDULE_ERROR = 'DELETE_AVAILABILITY_SCHEDULE_ERROR'

export const UPDATE_AVAILABILITY_SCHEDULE_WEEKDAY_BEGIN = 'UPDATE_AVAILABILITY_SCHEDULE_WEEKDAY_BEGIN'
export const UPDATE_AVAILABILITY_SCHEDULE_WEEKDAY_SUCCESS = 'UPDATE_AVAILABILITY_SCHEDULE_WEEKDAY_SUCCESS'
export const UPDATE_AVAILABILITY_SCHEDULE_WEEKDAY_ERROR = 'UPDATE_AVAILABILITY_SCHEDULE_WEEKDAY_ERROR'

export const UPDATE_AVAILABILITY_SCHEDULE_FROM_TIME_BEGIN = 'UPDATE_AVAILABILITY_SCHEDULE_FROM_TIME_BEGIN'
export const UPDATE_AVAILABILITY_SCHEDULE_FROM_TIME_SUCCESS = 'UPDATE_AVAILABILITY_SCHEDULE_FROM_TIME_SUCCESS'
export const UPDATE_AVAILABILITY_SCHEDULE_FROM_TIME_ERROR = 'UPDATE_AVAILABILITY_SCHEDULE_FROM_TIME_ERROR'

export const UPDATE_AVAILABILITY_SCHEDULE_TO_TIME_BEGIN = 'UPDATE_AVAILABILITY_SCHEDULE_TO_TIME_BEGIN'
export const UPDATE_AVAILABILITY_SCHEDULE_TO_TIME_SUCCESS = 'UPDATE_AVAILABILITY_SCHEDULE_TO_TIME_SUCCESS'
export const UPDATE_AVAILABILITY_SCHEDULE_TO_TIME_ERROR = 'UPDATE_AVAILABILITY_SCHEDULE_TO_TIME_ERROR'

export const ADD_USER_AVAILABILITY_TEMPLATE_BEGIN = 'ADD_USER_AVAILABILITY_TEMPLATE_BEGIN'
export const ADD_USER_AVAILABILITY_TEMPLATE_SUCCESS = 'ADD_USER_AVAILABILITY_TEMPLATE_SUCCESS'
export const ADD_USER_AVAILABILITY_TEMPLATE_ERROR = 'ADD_USER_AVAILABILITY_TEMPLATE_ERROR'
